export const UserManagement = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="24" cy="18" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="15" cy="11" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M29 29V26C29 24.8954 28.1046 24 27 24H21C19.8954 24 19 24.8954 19 26V29" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M18 17H12C10.8954 17 10 17.8954 10 19V22" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M25 10V3H3V16.0707C3 21.933 6.92368 27.0701 12.5795 28.6126L14 29" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
